import api from 'common/api'

export const onAcademicFocusesKeywordSearch = () => {
  return api.get('/api/academicfocus/keyword')
}

export const onAcademicMajorsSearch = (val, focusOnly) => {
  return api.get(
    `/api/academicfocus/majors?search=${encodeURI(val)}&majorsPageSize=15&typeahead=y&separateGenerals=true${
      focusOnly ? '&focusOnly=true' : ''
    }`,
  )
}
